export const MAX_CHARACTERS = 1000;
